<div class="w-full h-full inline-block align-middle">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payJustNowLogo.svg" alt="masterpass logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Please wait while we validate your Masterpass™ transaction</b></h3>
    </div>
</div>
